import React from 'react';
import ImportPDF from '../components/importPDF';

const Import = () => {
    return (
      <div>
        <ImportPDF/>
      </div>
    );
  };
  
  export default Import;